<template>
    <div class="row q-col-gutter-lg">
        <div id="circularProgressContainer">
            <CircularProgress />			
        </div>
        <div class="col-xs-8" id="pageTitleContainer">
            <div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
            <div v-if="description" class="q-py-xs" id="pageDescription">{{ $t(description) }}</div>
        </div>
    </div>
    <q-separator class="q-my-md" id="separator" />
    <div class="q-py-xs" id="pageContent">
        <span v-html="inductionContent" />
        <div v-if="isPdf" id="pdfContent">
            <div @scroll="isPdfRead" id="pdfPages" />
            <div class="pdfInstructionsContainer">
                <span class="pdfInstructions">{{ $t(pdfInstructionText) }}</span>
            </div>
        </div>
    </div>
    <q-option-group
        id="radioBtnOptionGroup"
        :options="[{ label: $t(agreeBtnText), value: true }, { label: $t(disagreeBtnText), value: false }]"
        type="radio"
        v-model="isCompleted"
        :disable="disableOptions"
    />
</template>

<style lang="less" scoped src="./induction-page.less"></style>
<script lang="ts" src="./induction-page.ts"></script>
